import React from "react";
import { Grid2, Typography, Box, Grid, Container, Button } from "@mui/material";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import styles from "./SignUpCongrats.module.css";
import aadharPic from "../../../Assets/Images/aadharPic.svg";
import panPic from "../../../Assets/Images/panPic.svg";
import Logo from '../../../Assets/Images/logo.svg';
import BankCard from "../../../Assets/Images/bankCardIcon.svg"
import PassPort from "../../../Assets/Images/PasswordIcon.svg"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../../Redux/usersSlice";
import {  useSteps  } from "../StepperComponents"; // Import steps
import collab from '../../../Assets/Images/collab1.svg';



const SignUpCongrats = () => {
  const steps = useSteps();
  console.log('STEPS',steps)
  const {userData,source} = useSelector( state => state.user);
  const navigate=useNavigate()
  const dispatch=useDispatch()
 
  React.useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "welcome_page_viewed",
      page_path: window.location.pathname
    });
  }, []);


    const handleNavigateTostep1=()=>{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "welcome_page_proceed",
        page_path: window.location.pathname
      });
      let nextIncompleteStep = null;
      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        const isComplete = step.substeps
          ? step.substeps.every(sub => userData.steps[sub.name]?.status)
          : userData.steps[step.name]?.status;

        if (!isComplete) {
          nextIncompleteStep = step;
          console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
          break;
        }
      }

      const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep?.path);
      console.log("Navigating to the specific step according to the condition", stepIndex)
      if (stepIndex !== -1) {
        dispatch(setActiveStep(stepIndex));
        navigate(nextIncompleteStep.path);
      }

    }
  return (
    <main>
      <Grid2
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${SignUpBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflowX: "hidden",
        }}
      >
           <img
            src={source == "cosmos" ? collab : Logo}
            alt="Logo"
            className={source == "cosmos" ? styles.twologo : styles.nav_logo}
            style={{  marginBottom: "15px" ,marginTop: "30px" }} // Adjust width & spacing as needed
          />
        {
          source == "cosmos" &&
          <Typography className={styles.txt}>
            Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
          </Typography>
        }
        <Typography className={styles.heading}>
          Welcome to Tradeboss Family
        </Typography>

        <Typography className={styles.documentsHeading}>
          Please Keep below documents Handy
        </Typography>
        <Container
          maxWidth={false}
          sx={{
            py: 3,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              mx: "auto", // Centers the box horizontally
              px: {
                xs: 2,
                sm: 3,
                md: 4,
                lg: 5,
              },
            }}
          >
            <Grid
              container
              spacing={3}
              sx={{
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {/* Left Side */}
              <Grid item xs={12} lg={6}>
                {/* <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px !important",
                  }}
                >
                  <Box
                    sx={{ flex: 1, height: "1px", backgroundColor: "#9A9A9A" }}
                  />
                  <Typography
                    sx={{ mx: 2, fontSize: "14px", fontFamily: "Inter400" }}
                  >
                    Indian
                  </Typography>
                  <Box
                    sx={{ flex: 1, height: "1px", backgroundColor: "#9A9A9A" }}
                  />
                </Grid> */}
                <Grid
                  container
                  spacing={2}
                  sx={{
                    px: { md: 2 }, // Add padding on medium and up screens
                  }}
                >
                  {/* Aadhar Number */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          1
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Aadhar number
                      </Typography>
                      <Box
                        component="img"
                        src={aadharPic}
                        alt="aadharPic"
                        sx={{ width: 62, height: 42 }}
                      />
                    </Box>
                  </Grid>

                  {/* PAN Number */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          2
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        PAN number
                      </Typography>
                      <Box
                        component="img"
                        src={panPic}
                        alt="panPic"
                        sx={{ width: 62, height: 42 }}
                      />
                    </Box>
                  </Grid>

                  {/* Bank Account */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          3
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Bank account number
                      </Typography>
                      <Box
                        component="img"
                        src={BankCard}
                        alt="BankPic"
                        sx={{ width: 62, height: 42 }}
                      />
                    </Box>
                  </Grid>

                  {/* Nominee Aadhar */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          4
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Nominee Aadhar
                      </Typography>
                      <Box
                        component="img"
                        src={aadharPic}
                        alt="aadharPic"
                        sx={{ width: 62, height: 42 }}
                      />
                    </Box>
                  </Grid>

                  {/* Bank Statement */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          5
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Six months Bank statement for F & O
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Rest of left side items remain the same */}
                  {/* ... */}
                </Grid>
              </Grid>

              {/* Right Side */}
              {/* <Grid item xs={12} lg={6}> */}
                {/* <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px !important",
                  }}
                >
                  <Box
                    sx={{ flex: 1, height: "1px", backgroundColor: "#9A9A9A" }}
                  />
                  <Typography
                    sx={{ mx: 2, fontSize: "14px", fontFamily: "Inter400" }}
                  >
                    For NRI Users
                  </Typography>
                  <Box
                    sx={{ flex: 1, height: "1px", backgroundColor: "#9A9A9A" }}
                  />
                </Grid> */}
                {/* <Grid
                  container
                  spacing={2}
                  sx={{
                    px: { md: 2 }, // Add padding on medium and up screens
                  }}
                > */}
                  {/* Passport */}
                  {/* <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          1
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Valid passport with visa
                      </Typography>
                      <Box
                        component="img"
                        src={PassPort}
                        alt="PassPort"
                        sx={{ width: 62, height: 42 }}
                      />
                    </Box>
                  </Grid> */}

                  {/* Foreign Address */}
                  {/* <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          2
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Foreign address Proof
                      </Typography>
                      <Box
                        sx={{
                          width: 62,
                          height: 42,
                          backgroundColor: "#C4C4C4",
                          borderRadius: "4px",
                        }}
                      />
                    </Box>
                  </Grid> */}

                  {/* RBI Permission */}
                  {/* <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        backgroundColor: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          width: 31,
                          height: 31,
                          borderRadius: "50%",
                          backgroundColor: "#DFE0EB",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{ color: "#000000", fontFamily: "Inter900" }}
                        >
                          3
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          flex: 1,
                          fontFamily: "Inter400",
                          fontSize: "14px",
                          lineHeight: "18px",
                        }}
                        className={styles.doctextname}
                      >
                        Copy of RBI permission / approval ( portfolio investment
                        scheme)
                      </Typography>
                    </Box>
                  </Grid> */}

                  {/* Rest of right side items remain the same */}
                  {/* ... */}
                {/* </Grid> */}
              {/* </Grid> */}
            </Grid>
          </Box>
        </Container>

        <Typography className={styles.description}>
          To proceed with account opening, SEBI requires a few documents to
          verify your identity and financial background.
        </Typography>

        <Grid2 className={styles.button_card}>
          <Button className={styles.button} onClick={handleNavigateTostep1}>Proceed</Button>
        </Grid2>
      </Grid2>
    </main>
  );
};

export default SignUpCongrats;
